import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import MoreVertSharpIcon from "@mui/icons-material/MoreVertSharp";
import PaletteIcon from "@mui/icons-material/Palette";
import SaveIcon from "@mui/icons-material/Save";
import DownloadIcon from "@mui/icons-material/Download";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Backdrop, SpeedDial, SpeedDialAction } from "@mui/material";
import * as React from "react";
import MovieMaker from "../../../SketchUtilities/MovieMaker/MovieMakerComponent";
import { BrushShortcutMenus } from "./BrushShortcutMenus";
import { BrushSettingsModal } from "./BrushSettingsModal";
import { useAuth } from "../../../../Context/AuthContext";
import { useEffect } from "react";

interface navBarProps {
  setOpenSpeedDial: (val: boolean) => void;
  openSpeedDial: boolean;
  openBrush: () => void;
  openColors: () => void;
  undo: () => void;
  redo: () => void;
  saveImage: () => void;
  downloadImage: () => void;
  newCanvas: () => void;
  onLogin?: () => void;
  onLogout?: () => void;
  onRegister?: () => void;
}

export const NavBar = (props: navBarProps) => {
  const { setOpenSpeedDial, openSpeedDial } = props;
  const auth = useAuth();

  // Fixed position at bottom, expands upward
  const speedDialStyle = {
    position: "absolute" as const,
    bottom: "0px",
    right: "0px",
  };

  return (
    <div className={"mobileNavBar"} id={"topBrush"}>
      <div
        className={"navBarItem"}
        style={{ borderRight: "1px solid black", flex: "1" }}
        onClick={() => {
          props.openBrush();
        }}
      >
        <img
          alt="Blush"
          style={{ width: "35px", height: "35px" }}
          src={require("../../../../../Assets/brushIcon.png")}
        />
      </div>
      <div
        className={"navBarItem"}
        style={{
          borderRight: "1px solid black",
          flex: "1",
        }}
        onClick={() => {
          props.openColors();
        }}
      >
        <PaletteIcon />
      </div>
      <div
        className={"shortcutMenuItemContainer"}
        style={{ borderRight: "1px solid black" }}
      >
        <BrushShortcutMenus />
      </div>
      <div
        className={"navBarItem"}
        style={{ flex: 1, borderRight: "1px solid black" }}
        onClick={() => {
          props.undo();
        }}
      >
        {" "}
        <img
          alt="undo"
          style={{ width: "35px", height: "35px" }}
          src={require("../../../../../Assets/undo.svg")}
        />
      </div>
      {MovieMaker()}
      <div
        className="navBarItem"
        style={{ width: "50px", display: "flex", position: "relative" }}
      >
        <MoreVertSharpIcon
          style={{ width: "auto" }}
          onClick={() => {
            if (!openSpeedDial) {
              setOpenSpeedDial(true);
            }
          }}
        />
        <Backdrop open={openSpeedDial} />
        <SpeedDial
          ariaLabel="SpeedDial"
          className={"navBarSpeedDial"}
          open={openSpeedDial}
          style={speedDialStyle}
        >
          {/* Auth items appear at the top */}
          {!auth.state.isLoggedIn && (
            <SpeedDialAction
              icon={<AccountCircleIcon />}
              tooltipTitle={`Login / Register`}
              onClick={() => {
                if (props.onRegister) {
                  props.onRegister();
                }
                if (openSpeedDial) {
                  setOpenSpeedDial(false);
                }
              }}
            />
          )}
          {auth.state.isLoggedIn && (
            <SpeedDialAction
              icon={<ArrowBackIosIcon />}
              tooltipTitle={`Logout`}
              onClick={() => {
                if (props.onLogout) {
                  props.onLogout();
                }
                if (openSpeedDial) {
                  setOpenSpeedDial(false);
                }
              }}
            />
          )}
          {/* Other actions */}
          <SpeedDialAction
            icon={<DownloadIcon />}
            tooltipTitle={`Download Image`}
            onClick={() => {
              console.info("download......");
              props.downloadImage();
              if (openSpeedDial) {
                setOpenSpeedDial(false);
              }
            }}
          />
          <SpeedDialAction
            icon={<SaveIcon />}
            tooltipTitle={`Save Image`}
            onClick={() => {
              console.info("save......");
              props.saveImage();
              if (openSpeedDial) {
                setOpenSpeedDial(false);
              }
            }}
          />
          <SpeedDialAction
            icon={<AddIcon />}
            tooltipTitle={"New Canvas"}
            onClick={() => {
              props.newCanvas();
              if (openSpeedDial) {
                setOpenSpeedDial(false);
              }
            }}
          />
          {/* Close button at the bottom - put it LAST so it appears at bottom */}
          <SpeedDialAction
            icon={<CloseIcon />}
            tooltipTitle={`Close`}
            onClick={() => {
              if (openSpeedDial) {
                setOpenSpeedDial(false);
              }
            }}
          />
        </SpeedDial>
      </div>
      <BrushSettingsModal />
    </div>
  );
};
